import { render, staticRenderFns } from "./TablesHome.vue?vue&type=template&id=d60b0d86&scoped=true"
import script from "./TablesHome.vue?vue&type=script&lang=js"
export * from "./TablesHome.vue?vue&type=script&lang=js"
import style0 from "./TablesHome.vue?vue&type=style&index=0&id=d60b0d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60b0d86",
  null
  
)

export default component.exports